import axios from 'axios';

const baseURL = (process.env.REACT_APP_API_BASE_URL as string) || '/api';

// Отладка: логируем используемый baseURL
console.log('[API Client] Base URL:', baseURL);
console.log('[API Client] REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL || 'не установлен (используется дефолт /api)');

// Глобальная переменная для хранения функции показа уведомлений
let showToastFn: ((message: string, type?: 'error' | 'success' | 'info' | 'warning') => void) | null = null;

export const setToastFunction = (fn: (message: string, type?: 'error' | 'success' | 'info' | 'warning') => void) => {
  showToastFn = fn;
};

export const apiClient = axios.create({
  baseURL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers = config.headers ?? {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      // В случае 401 чистим токен и пользователя
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      // Редиректим на страницу логина только если мы не уже на ней
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    } else if (error.response?.status === 403) {
      // В случае 403 показываем сообщение об отсутствии доступа
      const message = error.response?.data?.message || 'У вас нет доступа к данной операции или разделу.';
      if (showToastFn) {
        showToastFn(message, 'error');
      } else {
        // Fallback на alert, если toast еще не инициализирован
        window.alert(message);
      }
    } else if (error.response?.status === 400) {
      // В случае 400 показываем сообщение об ошибке валидации только через toast
      // Не показываем alert, чтобы компоненты могли обработать ошибку самостоятельно
      const message = error.response?.data?.message || 'Ошибка при выполнении запроса.';
      if (showToastFn) {
        showToastFn(message, 'error');
      }
      // Не показываем alert здесь, чтобы избежать дублирования с компонентами
    }
    return Promise.reject(error);
  }
);

export type LoginRequest = { email: string; password: string };
export type RegisterRequest = { email: string; password: string };
export type GoogleAuthRequest = { token: string };
export type LoginResponse = { 
  token: string; 
  user: { 
    id: string; 
    email: string; 
    roles: string[];
    preferredLanguage: string;
  } 
};

export async function login(req: LoginRequest): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', req);
  return data;
}

export async function register(req: RegisterRequest): Promise<void> {
  await apiClient.post('/auth/register', req);
}

export async function googleAuth(req: GoogleAuthRequest): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/google', req);
  return data;
}
